import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { ChangeRequestRoutes } from './change-request.routing';
import { ChangeRequestComponent } from './changerequest/changerequest.component';
import { ChangeRequestLineItemComponent } from './changerequest-line-item/changerequest-line-item.component';
import { CommonModule } from '../../../node_modules/@angular/common';
import { FormsModule } from '@angular/forms';
import { ChangeRequestService } from '../services/changerequest.service';
import { ChangeRequestAffirmationsComponent } from './changerequest-create-affirmations/changerequest-create-affirmations.component';
import { EstDatePipe } from '../shared/estdate.pipe';
import { ButtonModule } from 'primeng/button';
import { StepsModule } from 'primeng/steps';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';


@NgModule({
  declarations: [ChangeRequestComponent, ChangeRequestLineItemComponent, ChangeRequestAffirmationsComponent, EstDatePipe],
  imports: [ChangeRequestRoutes, ButtonModule,
    StepsModule,
    DialogModule,
    InputTextModule,
    CalendarModule,
    SliderModule,
    DropdownModule,
    AccordionModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputTextareaModule, CommonModule, FormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [ChangeRequestComponent, EstDatePipe],
  providers: [ChangeRequestService]

})
export class ChangeRequestModule {
}
